import React, { useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';

const ResetPasswordPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const token = searchParams.get('token');

  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (!token) {
      setError('Ссылка восстановления недействительна');
      return;
    }

    if (password.length < 8) {
      setError('Пароль должен содержать минимум 8 символов');
      return;
    }

    if (password !== confirmPassword) {
      setError('Пароли не совпадают');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const res = await fetch('/api/auth/reset-password', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, new_password: password }),
      });

      const data = await res.json();

      if (data.success) {
        setSuccess(true);
      } else {
        setError(data.message || 'Ошибка');
      }
    } catch {
      setError('Ошибка соединения с сервером');
    } finally {
      setLoading(false);
    }
  };

  const inputStyle: React.CSSProperties = {
    width: '100%',
    padding: '14px 16px',
    background: 'rgba(255, 255, 255, 0.06)',
    border: '1px solid rgba(212, 175, 55, 0.25)',
    borderRadius: '12px',
    color: '#fff',
    fontSize: '16px',
    boxSizing: 'border-box',
    outline: 'none',
    transition: 'border-color 0.3s',
  };

  if (!token) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a2e 100%)',
        padding: '20px',
      }}>
        <div style={{
          background: 'rgba(13, 20, 40, 0.85)',
          backdropFilter: 'blur(20px)',
          border: '1px solid rgba(212, 175, 55, 0.12)',
          borderRadius: '24px',
          padding: '50px 40px',
          maxWidth: '460px',
          width: '100%',
          textAlign: 'center',
        }}>
          <div style={{ fontSize: '64px', marginBottom: '20px' }}>⚠️</div>
          <h2 style={{ color: '#ff6b6b', fontSize: '24px', fontFamily: 'var(--font-display)', fontStyle: 'italic', marginBottom: '16px' }}>
            Неверная ссылка
          </h2>
          <p style={{ color: '#999', fontSize: '15px', marginBottom: '24px' }}>
            Ссылка для восстановления пароля недействительна или истекла.
          </p>
          <Link to="/forgot-password" style={{
            display: 'inline-block',
            padding: '12px 32px',
            background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
            borderRadius: '12px',
            color: '#0a0a1a',
            textDecoration: 'none',
            fontWeight: '600',
            fontSize: '15px',
          }}>
            Запросить новую ссылку
          </Link>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(180deg, #0a0a1a 0%, #1a1a2e 100%)',
      padding: '20px',
    }}>
      <div style={{
        background: 'rgba(13, 20, 40, 0.85)',
        backdropFilter: 'blur(20px)',
        border: '1px solid rgba(212, 175, 55, 0.12)',
        borderRadius: '24px',
        padding: '50px 40px',
        maxWidth: '460px',
        width: '100%',
        textAlign: 'center',
        boxShadow: '0 8px 40px rgba(212, 175, 55, 0.08), inset 0 0 40px rgba(13, 20, 40, 0.5)',
        position: 'relative',
      }}>
        <div style={{ position: 'absolute', top: 0, left: '10%', right: '10%', height: '2px', background: 'linear-gradient(90deg, transparent, #d4af37, transparent)' }} />

        {!success ? (
          <>
            <div style={{ fontSize: '48px', marginBottom: '20px' }}>🔐</div>
            <h1 style={{
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              fontSize: '28px',
              fontWeight: 'bold',
              marginBottom: '12px',
              background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Новый пароль
            </h1>
            <p style={{ color: '#999', fontSize: '15px', lineHeight: '1.6', marginBottom: '30px' }}>
              Придумайте надёжный пароль для вашего аккаунта
            </p>

            {error && (
              <div style={{
                background: 'rgba(220, 53, 69, 0.15)',
                border: '1px solid rgba(220, 53, 69, 0.4)',
                color: '#ff6b6b',
                padding: '12px 16px',
                borderRadius: '12px',
                marginBottom: '20px',
                fontSize: '14px',
              }}>
                {error}
              </div>
            )}

            <form onSubmit={handleSubmit}>
              <div style={{ marginBottom: '16px', textAlign: 'left' }}>
                <label style={{ display: 'block', color: '#d4af37', marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>
                  Новый пароль
                </label>
                <input
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                  minLength={8}
                  placeholder="Минимум 8 символов"
                  style={inputStyle}
                  onFocus={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.6)'; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.25)'; }}
                />
              </div>

              <div style={{ marginBottom: '24px', textAlign: 'left' }}>
                <label style={{ display: 'block', color: '#d4af37', marginBottom: '8px', fontSize: '14px', fontWeight: 500 }}>
                  Повторите пароль
                </label>
                <input
                  type="password"
                  value={confirmPassword}
                  onChange={(e) => setConfirmPassword(e.target.value)}
                  required
                  placeholder="Повторите пароль"
                  style={inputStyle}
                  onFocus={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.6)'; }}
                  onBlur={(e) => { e.currentTarget.style.borderColor = 'rgba(212, 175, 55, 0.25)'; }}
                />
              </div>

              <button
                type="submit"
                disabled={loading}
                style={{
                  width: '100%',
                  padding: '14px',
                  background: loading ? 'rgba(212, 175, 55, 0.3)' : 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                  border: 'none',
                  borderRadius: '12px',
                  color: '#0a0a1a',
                  fontSize: '16px',
                  fontWeight: '600',
                  cursor: loading ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s',
                  fontFamily: 'var(--font-sans)',
                }}
              >
                {loading ? 'Сохранение...' : 'Установить пароль'}
              </button>
            </form>
          </>
        ) : (
          <>
            <div style={{ fontSize: '64px', marginBottom: '20px' }}>✨</div>
            <h2 style={{
              fontFamily: 'var(--font-display)',
              fontStyle: 'italic',
              fontSize: '26px',
              fontWeight: 'bold',
              marginBottom: '16px',
              background: 'linear-gradient(135deg, #F4E4A6 0%, #D4AF37 40%, #B8942B 70%, #F4E4A6 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text',
            }}>
              Пароль изменён!
            </h2>
            <p style={{ color: '#ccc', fontSize: '15px', lineHeight: '1.7', marginBottom: '30px' }}>
              Ваш пароль успешно обновлён. Теперь вы можете войти в аккаунт с новым паролем.
            </p>

            <button
              onClick={() => navigate('/login')}
              style={{
                padding: '14px 40px',
                background: 'linear-gradient(135deg, #d4af37 0%, #f4d03f 100%)',
                border: 'none',
                borderRadius: '12px',
                color: '#0a0a1a',
                fontSize: '16px',
                fontWeight: '600',
                cursor: 'pointer',
                fontFamily: 'var(--font-sans)',
              }}
            >
              Войти в аккаунт
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default ResetPasswordPage;
